var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDribbbleLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "dribbble-dribble-dribbbble-svgrepo-com",
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M23.637,16.812C20.825,11.5,17.856,6.5,14.731,1.5A24.588,24.588,0,0,0,.2,20.562,70.537,70.537,0,0,0,23.637,16.812Z",
    transform: "translate(0.113 0.844)",
    fill: "#592e83"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M20.306,16.563A104.913,104.913,0,0,0,37.025,8.125,25.018,25.018,0,0,0,18.587,0,21.648,21.648,0,0,0,11.4,1.094Q16.088,8.594,20.306,16.563Z",
    transform: "translate(6.412)",
    fill: "#592e83"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M20.969,22.012a53.893,53.893,0,0,1,14.219-2.031,43.909,43.909,0,0,1,4.531.156A24.723,24.723,0,0,0,35.188,6.7,95.1,95.1,0,0,1,18,15.606C18.938,17.794,20.031,19.825,20.969,22.012Z",
    transform: "translate(10.125 3.769)",
    fill: "#592e83"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M28.125,19.406C27.188,17.219,26.094,15.188,25,13A71.07,71.07,0,0,1,2.187,17.063H0v.625a24.852,24.852,0,0,0,6.094,16.25A55.436,55.436,0,0,1,28.125,19.406Z",
    transform: "translate(0 7.313)",
    fill: "#592e83"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M33.769,17.3A51.843,51.843,0,0,0,20.8,19.019c2.5,5.469,4.531,11.25,6.563,17.031A25.123,25.123,0,0,0,38.3,17.612,22.882,22.882,0,0,0,33.769,17.3Z",
    transform: "translate(11.7 9.731)",
    fill: "#592e83"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M26.55,19A50.842,50.842,0,0,0,5.3,32.906a25.237,25.237,0,0,0,16.719,6.406,24.857,24.857,0,0,0,11.25-2.656C31.238,30.562,29.05,24.781,26.55,19Z",
    transform: "translate(2.981 10.688)",
    fill: "#592e83"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDribbbleLogo);
export default __webpack_public_path__ + "static/media/Dribbble-logo.095828a9e9ede67326f8ed2f70a61457.svg";
export { ForwardRef as ReactComponent };